import React from 'react';
import { StyledIconContainer } from './NotesPreviewCardStyles';
import { FaEnvelope, FaPhoneAlt, FaStickyNote, FaTasks } from 'react-icons/fa';
import { Box } from '@qwealth/qcore';

interface DateIconProps {
  month: string;
  day: string;
}

const DateIcon: React.FC<DateIconProps> = ({ month, day }) => (
  <Box
    backgroundColor="white"
    color="primary"
    borderRadius="default"
    alignItems="center"
    flexDirection="column"
    display="flex"
    p="default"
  >
    <Box fontWeight="bold" fontSize="small" textTransform="uppercase">
      {month}
    </Box>
    {/* @ts-ignore */}
    <Box fontWeight="bold" fontSize="24px" lineHeight="normal">
      {day}
    </Box>
  </Box>
);

export default DateIcon;
